import { render, staticRenderFns } from "./new_pagination.vue?vue&type=template&id=681cd9df&scoped=true"
import script from "./new_pagination.vue?vue&type=script&lang=js"
export * from "./new_pagination.vue?vue&type=script&lang=js"
import style0 from "./new_pagination.vue?vue&type=style&index=0&id=681cd9df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681cd9df",
  null
  
)

export default component.exports